<script lang="ts" setup>
import BurgerButton from "~/components/BurgerButton.vue";
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();

const menuOpened = ref(false);

const navigation = ref([
  { to: "/elavtal", text: "Elavtal" },
  { to: "/foretag-brf", text: "Företag/BRF" },
  { to: "/salj-din-el", text: "Sälj din el" },
  { to: "/kundservice", text: "Kundservice" },
  { to: "/nyheter", text: "Nyheter" },
  { to: "/om-oss", text: "Om oss" },
]);

const isActive = (path: string) => {
  return route.path === path;
}

const toggleMenu = async (isOpened: boolean) => {
  menuOpened.value = isOpened;
};

watch(() => route.path, () => {
  menuOpened.value = false;
});

watch(menuOpened, (newValue) => {
  if (newValue) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
});

onUnmounted(() => {
  document.body.style.overflow = "auto";
});
</script>

<template>
  <div ref="$navMobile" class="nav-mobile bg-dark-blue sticky top-0 overflow-auto z-50 w-full" style="box-shadow: 0 2px 8px #000">
    <div class="pt-8 px-30">
      <div class="flex justify-between align-center mb-16">
        <div class="header__logo w-full max-w-[10rem] text-center">
          <router-link to="/">
            <svgo-logo class="block" />
          </router-link>
        </div>

        <div class="flex items-center translate-y-[0.4rem]">
          <BurgerButton :is-opened="menuOpened" @toggle="toggleMenu" />
        </div>
      </div>
      <transition name="slide">
        <div v-if="menuOpened" :class="[menuOpened ? 'visible' : 'hidden']" class="h-screen">
          <a
            class="bg-cyan text-dark-blue w-full flex items-center justify-center text-center text-25 font-semibold rounded-6 mb-40 mt-60 h-70"
            href="/bli-kund">Bli kund
          </a>

          <div>
            <ul class="mb-40">
              <li class="py-4" v-for="(nav, i) in navigation" :key="i">
                <nuxt-link
                  :to="nav.to"
                  :key="i"
                  :class="{ 'text-cyan font-semibold text-25': isActive(nav.to)}"
                  class="text-gray-light font-semibold text-25"
                  @click="() => {
                    menuOpened = false
                    toggleMenu(false)
                  }"
                  >{{ nav.text }}</nuxt-link>
              </li>
            </ul>

            <div class="flex mb-60">
              <a class="flex items-center mr-16" href="https://www.facebook.com/KarnkraftSe" target="_blank">
                <div class="border-2 border-white rounded-xl w-25 h-25 flex items-center justify-center"
                     style="width: 30px; height: 30px; border-radius: 10px">
                  <svgo-facebook width="15" />
                </div>
              </a>
              <a class="flex items-center" href="https://www.twitter.com/KarnkraftSe" target="_blank">
                <div class="border-2 border-white rounded-xl w-25 h-25 flex items-center justify-center"
                     style="width: 30px; height: 30px; border-radius: 10px">
                  <svgo-twitter width="20" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.slide-enter-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-leave-active {
  transition: transform 0.1s ease, opacity 0.1s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
.slide-enter-to,
.slide-leave-from {
  transform: translateY(0);
  opacity: 1;
}
</style>
